import { render, staticRenderFns } from "./milestone_token.vue.js?vue&type=template&id=39a1f55e&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./milestone_token.vue?vue&type=template&id=39a1f55e&vue3"
import script from "./milestone_token.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./milestone_token.vue?vue&type=script&lang=js&vue3"
export * from "./milestone_token.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./milestone_token.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports